export const divideThousands = (number, divider = ' ') =>
    ('' + number).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1' + divider);

/**
 * @param {number|string} num
 * @param {Object?} options
 * @param {boolean?} options.zeroToFree
 * @param {boolean?} options.addRoubleSign
 * @param {boolean?} options.toFixed
 * @param {boolean?} options.onlyDecimalToFixed
 */
export const formatNum = (
    num,
    { zeroToFree, addRoubleSign, toFixed, onlyDecimalToFixed } = {},
) => {
    num = +num;

    const isDecimal = num % 1 !== 0;

    if (
        toFixed !== undefined ||
        (onlyDecimalToFixed !== undefined && isDecimal)
    ) {
        num = (+num).toFixed(toFixed || onlyDecimalToFixed);
    }

    num = divideThousands(num);

    if (zeroToFree && num === '0') {
        num = 'бесплатно';
    } else if (addRoubleSign) {
        num += ' ₽';
    }

    return num;
};
